var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "w-full flex flex-col gap-2"
  }, [_c('Alert', {
    staticClass: "bg-[#FFF6D9]",
    attrs: {
      "type": "warning",
      "closable": ""
    }
  }, [_c('span', {
    staticClass: "text-[#FF6700] py-2"
  }, [_vm._v($t("95gbgpa", "控制谁可以访问本应用"))])]), _c('div', {
    staticClass: "flex-1 gap-2 flex flex-col"
  }, [_c('div', {
    staticClass: "flex gap-2 items-center ml-1"
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "suffix": "ios-search",
      "placeholder": $t("uwz96k8", "搜索授权主体名称")
    },
    on: {
      "on-enter": _vm.searchTable
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addMember
    }
  }, [_vm._v($t("e7yhal4", "添加成员"))]), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selections.length > 0,
      expression: "selections.length > 0"
    }],
    attrs: {
      "type": "error"
    },
    on: {
      "click": _vm.deleteMember
    }
  }, [_vm._v(` ${$t("lknd2", "移除")} `)])], 1), _c('pro-table', _vm._b({
    ref: "proTableRef",
    on: {
      "on-selection-change": _vm.handleSelectionChange
    },
    model: {
      value: _vm.users,
      callback: function ($$v) {
        _vm.users = $$v;
      },
      expression: "users"
    }
  }, 'pro-table', _vm.config, false))], 1), _c('org-tree-modal', {
    ref: "orgTreeModalRef",
    on: {
      "on-update": _vm.getData
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };